import { createSlice } from '@reduxjs/toolkit';
import { IRequestDetailState, RequestDetailEmptyState } from './requestdetailState';
import {
  fetchRequestById,
  fetchResponsesByRequest,
  fetchRequests,
  execArchiveRequest,
  remindAgency,
  remindAll,
} from './requestdetailThunk';
import { QueryState } from 'common/enums';

const initialState: IRequestDetailState = RequestDetailEmptyState;

export const requestdetailSlice = createSlice({
  name: 'requestDetail',
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchRequestById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRequestById.fulfilled, (state, action) => {
        state.loading = false;
        state.request = action.payload || null;
      })
      .addCase(fetchRequestById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Something went wrong!';
      })
      .addCase(fetchResponsesByRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchResponsesByRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.responses = action.payload || [];
      })
      .addCase(fetchResponsesByRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Something went wrong!';
      })
      .addCase(fetchRequests.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.requests = action.payload;
      })
      .addCase(fetchRequests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Something went wrong!';
      })
      .addCase(execArchiveRequest.pending, (state) => {
        state.processing = true;
        state.serviceAction = QueryState.ARCHIVED;
      })
      .addCase(execArchiveRequest.fulfilled, (state, action) => {
        state.processing = false;
        state.request = action.payload;
        state.serviceAction = QueryState.UNDEFINED;
      })
      .addCase(execArchiveRequest.rejected, (state, action) => {
        state.processing = false;
        state.error = action.error.message;
        state.serviceAction = QueryState.UNDEFINED;
      })
      .addCase(remindAgency.pending, (state) => {
        state.serviceAction = QueryState.NOTIFICATION;
        state.processing = true;
      })
      .addCase(remindAgency.fulfilled, (state) => {
        state.serviceAction = QueryState.READY;
        state.processing = false;
      })
      .addCase(remindAgency.rejected, (state, action) => {
        state.serviceAction = QueryState.FAIL;
        state.processing = false;
        state.error = action.error.message;
      })
      .addCase(remindAll.pending, (state) => {
        state.serviceAction = QueryState.NOTIFICATION;
        state.processing = true;
      })
      .addCase(remindAll.fulfilled, (state) => {
        state.serviceAction = QueryState.READY;
        state.processing = false;
      })
      .addCase(remindAll.rejected, (state, action) => {
        state.serviceAction = QueryState.FAIL;
        state.processing = false;
        state.error = action.error.message;
      });
  },
});

export const { resetState } = requestdetailSlice.actions;

export default requestdetailSlice.reducer;
